import { RETRIEVE_LOAD_USER_INFO } from "../actions/types";

const INITIAL_STATE = {
  displayError: false, // display to the ui and let user know there is a issue
  errors: [] // store status code, message from server, and message to user in array. element { status, message, messageToDisplay }
}

const netWorkErrorsReducer = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case RETRIEVE_LOAD_USER_INFO:
      if (action.payload.status !== 200) {
        const data = action.payload.data;
        const status = data.status;
        const message = data.message;
        const messageToDisplay = "Failed to connect to server. Your settings and your records cannot be retrieved. Please fresh your page or comeback later.";
        const errors = [{status, message, messageToDisplay}, ...state.errors];
        return { displayError: true, errors: errors };
      }
      return state;
    default: 
      return state;
  }
}

export default netWorkErrorsReducer;